import { boot } from 'quasar/wrappers'
import downloadFile from '../functions/download-file'

export default boot(({ app }) => {
	app.config.globalProperties.$downloadFile = downloadFile
})
